<pega-mijn
    (caseChange)="onCaseChange($event.caseId)"
    [caseTypeID]="caseTypeId"
    [closeUrl]="'pega.mijn.close' | apContent"
    [content]="content"
    [templateType]="templateType"
    [title]="title"
    [useState]="useState"
></pega-mijn>
